var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('IMMForm',{attrs:{"formTitle":"Contestatii","labelName":"Referitoare la proiect","inputType":"textarea","textToCopy":"Copiază în clipboard","readonly":"","btn":"Adauga"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }